/**
 * StarTile - Collectible star (must collect all to win)
 */

import { BaseTile, TextureDescriptor } from "./BaseTile";
import { TILE } from "../constants/gameConstants";
import { TileIndex } from "../types";

export class StarTile extends BaseTile {
  constructor({ col, row, id }: { col: number; row: number; id?: string }) {
    super(id ?? `star-${col}-${row}`, col, row);
  }

  tileType(): TileIndex {
    return TILE.STAR;
  }

  textureDescriptor(): TextureDescriptor {
    return { type: "png", path: "tiles/star.png" };
  }

  clone(): StarTile {
    const copy = new StarTile({ col: this.col, row: this.row, id: this.id });
    copy.sprite = this.sprite;
    return copy;
  }

  toJSON(): Record<string, any> {
    return { type: "star", id: this.id, col: this.col, row: this.row };
  }
}
